// imports section Start
import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import { useStyles } from "../../assets/styles/Theme";
import { Card, Grid, Typography, Button, IconButton } from "@mui/material";
import { formatDate, formatTime } from "../../utils/common/DateFormat";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { currencyFormat } from "../../utils/common/CurrencyFormat";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// imports section End

const UberOrderItemCard = ({
  placedorderItem,
  onViewOrder,
  order,
  details,
  billDetails,
  setLoading,
  loading,
}) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Hooks end
  // Handlers start
  const formattedDate = formatDate(placedorderItem.data[0].order.created_time);
  const formattedTime = formatTime(placedorderItem.data[0].order.created_time);
  const formattedAmount = currencyFormat(
    placedorderItem.AMOUNT,
    placedorderItem.PREFCURRENCY
  );

  // Handlers end

  return (
    <Card sx={styles.po_card}>
      <Grid
        sx={{
          borderLeft: `4px solid #28B411`,
          paddingLeft: "8px",
        }}
      >
        <Grid sx={styles.po_card_content}>
          <Typography sx={styles.po_card_texts}>
            # {placedorderItem.data[0].order.display_id}
          </Typography>
          <Typography
            sx={{
              //   ...styles.po_card_id,
              color: theme.palette.input_field.text,
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {
              placedorderItem.data[0].order.payment.payment_detail.order_total
                .net.formatted
            }
          </Typography>
        </Grid>
        <Grid
          sx={{
            ...styles.po_card_content,
          }}
        >
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {placedorderItem.data[0].order.state}
          </Typography>
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {
              placedorderItem.data[0].order.payment.payment_detail.order_total
                .net.currency_code
            }
          </Typography>
        </Grid>
      </Grid>

      <Grid
        sx={{
          ...styles.po_card_content,
          borderTop: `1px solid ${theme.palette.stroke.main}`,
          //   borderRadius: 0,
          pt: 2,
          mt: 1,
        }}
      >
        <Typography sx={styles.po_card_text_numbers}>
          <IconButton sx={styles.po_card_icons}>
            <CalendarMonthIcon />
          </IconButton>
          {formattedDate}
        </Typography>
        <Typography sx={styles.po_card_text_numbers}>
          <IconButton sx={styles.po_card_icons}>
            <AccessTimeFilledIcon />
          </IconButton>
          {formattedTime}
        </Typography>
        <Typography
          sx={{
            ...styles.po_card_text_numbers,
            color: theme.palette.input_field.text,
          }}
        ></Typography>
      </Grid>
      <Button
        sx={styles.btn_primary}
        size="medium"
        variant="contained"
        // onClick={() => onViewOrder(placedorderItem)}
        onClick={() => onViewOrder(placedorderItem)}
      >
        View
      </Button>
    </Card>
  );
};

export default UberOrderItemCard;
